import { FeatureFlag } from '@ps/web-core-enums';

import { type WidgetEffectParams } from '@swf/core/store';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';
import { sportsWidgetPollingBehavior } from '@swf/sports/utils/actions';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';
import getErrorStatusCode from '@swf/sports/utils/getErrorStatusCode';

import type { EventPageSuccessResponse, WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(_payload: undefined, params: WidgetEffectParams<BasicSportsWidgetConfig>) {
    const { dispatch, select, rootState, widget } = params;
    const { clear, eventPageRequested }: WidgetDispatch = dispatch[widget.uid];
    const { hasPreloaded }: WidgetSelect = select[widget.uid];

    sportsWidgetPollingBehavior(params).subscribe({
      next: () => {
        eventPageRequested();
      },
      complete: () => {
        clear();
      }
    });

    if (!hasPreloaded(rootState)) {
      await eventPageRequested();
    }
  },
  async eventPageRequested(
    _payload: undefined,
    { dispatch, request, widget, rootState, select }: WidgetEffectParams<BasicSportsWidgetConfig>
  ) {
    const { eventId } = select.sports.getUrlParams(rootState);
    const sportsRequest = buildSportsRequest(request, rootState);
    const { eventPageLoadSuccess, eventPageLoadFailure }: WidgetDispatch = dispatch[widget.uid];

    try {
      const { body } = await sportsRequest<EventPageSuccessResponse>({
        path: `/event-page/${eventId}`,
        includeFeatures: [FeatureFlag.ISPBetBuilder]
      });

      eventPageLoadSuccess(body);
    } catch (error) {
      eventPageLoadFailure(getErrorStatusCode(error));
    }
    return;
  }
};
